import { takeEvery, call, put } from 'redux-saga/effects';
import { gcApi } from '../config/axios';
import {
    UPDATE_HYDRATION_LEVEL,
    UPDATE_HYDRATION_LEVEL_UPDATING,
    UPDATE_HYDRATION_LEVEL_SUCCESS,
    UPDATE_HYDRATION_LEVEL_ERROR,
    FETCH_HYDRATION_DATA,
    FETCH_HYDRATION_DATA_FETCHING,
    FETCH_HYDRATION_DATA_SUCCESS,
    FETCH_HYDRATION_DATA_FAIL,
    UPDATE_HYDRATION_ALL_DATA,
    UPDATE_HYDRATION_ALL_DATA_UPDATING,
    UPDATE_HYDRATION_ALL_DATA_SUCCESS,
    UPDATE_HYDRATION_ALL_DATA_ERROR,
    SET_VIEWER_USER_PREFERENCES
} from '../actions/ActionTypes';
import { handlingErrorCallback, handlingSuccessCallback } from './sagasUtils';

export function* updateHydrationLevel(action) {
    try {
        yield put({
            type: UPDATE_HYDRATION_LEVEL_UPDATING
        });

        const { userId, timestamp, value, calendarDate } = action.payload;
        const response = yield call(gcApi.put, `/usersummary-service/usersummary/hydration/log`, {
            userProfileId: userId,
            timestampLocal: timestamp,
            valueInML: value,
            calendarDate: calendarDate
        });

        yield put({
            type: UPDATE_HYDRATION_LEVEL_SUCCESS,
            response
        });
    } catch (e) {
        const response = yield call(
            gcApi.get,
            `/usersummary-service/usersummary/hydration/daily/${action.payload.calendarDate}`
        );

        yield put({
            type: UPDATE_HYDRATION_LEVEL_ERROR,
            response
        });
    }
}

export function* updateHydrationData(action) {
    try {
        yield put({
            type: UPDATE_HYDRATION_ALL_DATA_UPDATING
        });

        const { calendarDate } = action.payload;
        delete action.payload.calendarDate;

        const response = yield call(
            gcApi.put,
            `/usersummary-service/usersummary/hydration/allData/${calendarDate}`,
            action.payload
        );

        yield call(handlingSuccessCallback, action.callback, response);

        yield put({
            type: UPDATE_HYDRATION_ALL_DATA_SUCCESS,
            response
        });

        // hydration measurement unit is also in vieweruserpreferences
        // keep the models in sync
        yield put({
            type: SET_VIEWER_USER_PREFERENCES,
            data: {
                ...(!!response.data.hydrationMeasurementUnit && {
                    hydrationMeasurementUnit: action.payload.hydrationMeasurementUnit
                }),
                ...(!!response.data.hydrationContainers && { hydrationContainers: action.payload.hydrationContainers })
            }
        });
    } catch (e) {
        yield call(handlingErrorCallback, action.callback, e);
        yield put({
            type: UPDATE_HYDRATION_ALL_DATA_ERROR,
            e
        });
    }
}

export function* fetchHydrationData(action) {
    const { calendarDate } = action;

    try {
        yield put({
            type: FETCH_HYDRATION_DATA_FETCHING
        });

        const { calendarDate } = action.payload;
        const response = yield call(gcApi.get, `/usersummary-service/usersummary/hydration/allData/${calendarDate}`);

        yield put({
            type: FETCH_HYDRATION_DATA_SUCCESS,
            dailyHydrationData: response.data,
            calendarDate: calendarDate
        });
    } catch (e) {
        yield put({
            type: FETCH_HYDRATION_DATA_FAIL,
            dailyHydrationData: {},
            calendarDate: calendarDate
        });
    }
}

// watcher
export const hydrationSagas = [
    takeEvery(UPDATE_HYDRATION_LEVEL, updateHydrationLevel),
    takeEvery(UPDATE_HYDRATION_ALL_DATA, updateHydrationData),
    takeEvery(FETCH_HYDRATION_DATA, fetchHydrationData)
];
